// // =======================
// // DELIVERY BOX CART SYNC
// // =======================
// window.updateDeliveryBoxCart = async function() {
//   // console.log("FUNCTION CALLED !!");

//   // Prevent concurrent executions
//   if (window.__updatingDeliveryBoxCart) {
//     // console.log("Skipping, update already in progress");
//     return;
//   }
//   window.__updatingDeliveryBoxCart = true;

//   try {
//     // 1️⃣ Fetch current cart
//     const cart = await fetch('/cart.js').then(res => res.json());
//     if (!cart) return;

//     const metafieldMap = {}; // addonVariantId -> { qty, parents: Set() }
//     const metafieldVariantsSet = new Set();

//     // 2️⃣ Collect all product handles and fetch metafield data at once
//     const productHandles = [...new Set(cart.items.map(i => i.handle))];
//     if (productHandles.length === 0) {
//       // console.log("No product handles found");
//       return;
//     }

//     const joinedHandles = productHandles.join('@@');
//     const firstHandle = productHandles[0];
//     const ajaxURL = `/products/${firstHandle}?view=ajax-data&handle=${joinedHandles}`;

//     // console.log("Fetching combined metafields:", ajaxURL);

//     const res = await fetch(ajaxURL);
//     const text = await res.text();

//     // Expect JSON output like: {"handle1":123456789,"handle2":987654321}
//     let productDataCache = {};
//     try {
//       productDataCache = JSON.parse(text.trim());
//     } catch (e) {
//       console.warn("⚠️ Failed to parse metafield data, check template output:", text);
//     }

//     // Build quick lookup
//     for (const id of Object.values(productDataCache)) {
//       if (id && !isNaN(id)) metafieldVariantsSet.add(Number(id));
//     }

//     // 3️⃣ Build addon requirements (parents only)
//     for (const item of cart.items) {
//       if (metafieldVariantsSet.has(item.variant_id)) continue; // skip addons
//       const addonVariant = productDataCache[item.handle];
//       if (addonVariant && !isNaN(addonVariant)) {
//         if (!metafieldMap[addonVariant]) metafieldMap[addonVariant] = { qty: 0, parents: new Set() };
//         metafieldMap[addonVariant].qty += item.quantity;
//         metafieldMap[addonVariant].parents.add(item.product_id);
//       }
//     }

//     // console.log("metafieldMap:", metafieldMap);

//     // 4️⃣ Build map of existing cart variants
//     const existing = {};
//     cart.items.forEach(i => {
//       existing[i.variant_id] = { qty: i.quantity, key: i.key, properties: i.properties || {} };
//     });

//     // 5️⃣ Add or update addon items
//     for (const [variantId, data] of Object.entries(metafieldMap)) {
//       const desiredQty = data.qty;
//       const parentIds = Array.from(data.parents).join(',');
//       const props = { _delivery_parents: parentIds };
//       const existingItem = existing[variantId];

//         Rebuy.SmartCart.skip_open = true;


//       if (!existingItem) {
//         // console.log(`Adding addon ${variantId} → qty ${desiredQty}`);
//         await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: Number(variantId), quantity: desiredQty, properties: props })
//         });
//       } else {
//         const currentQty = existingItem.qty;
//         const currentProps = existingItem.properties._delivery_parents || '';
//         if (currentQty !== desiredQty || currentProps !== parentIds) {
//           // console.log(`Updating addon ${variantId} → qty ${desiredQty}, parents [${parentIds}]`);
//           await fetch('/cart/change.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               id: existingItem.key || Number(variantId),
//               quantity: desiredQty,
//               properties: props
//             })
//           });
//         }
//       }
//         setTimeout(() => { Rebuy.SmartCart.skip_open = false; }, 500);
//     }

//     // 6️⃣ Remove orphaned addons
//     const currentParentIds = new Set(cart.items.map(i => i.product_id));
//     for (const item of cart.items) {
//       if (item.properties && item.properties._delivery_parents) {
//         const parentIds = item.properties._delivery_parents
//           .split(',')
//           .map(v => v.trim())
//           .filter(Boolean);
//         const stillExists = parentIds.some(pid => currentParentIds.has(Number(pid)));
//         if (!stillExists) {
//           Rebuy.SmartCart.skip_open = true;
//           // console.log(`Removing orphan addon ${item.variant_id} (no valid parents left)`);
//           await fetch('/cart/change.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ id: item.key || item.variant_id, quantity: 0 })
//           });
//           setTimeout(() => { Rebuy.SmartCart.skip_open = false; }, 500);
//         }
//       }
//     }

//     // console.log("Delivery Box Cart Synced Successfully");
//   } catch (err) {
//     console.error("updateDeliveryBoxCart error:", err);
//   } finally {
//     window.__updatingDeliveryBoxCart = false;
//   }
// };

// // 🔄 Debounced event integration
// let rebuyUpdateTimeout;
// const debounceUpdate = () => {
//   clearTimeout(rebuyUpdateTimeout);
//   rebuyUpdateTimeout = setTimeout(() => window.updateDeliveryBoxCart(), 700);
// };

// document.addEventListener('rebuy:cart.change', debounceUpdate);
// document.addEventListener('rebuy:smartcart.line-item-increase', debounceUpdate);
// document.addEventListener('rebuy:smartcart.line-item-decrease', debounceUpdate);
// document.addEventListener('rebuy:smartcart.line-item-removed', () => {
//   // console.log("line-item-removed → waiting then cleaning");
//   setTimeout(() => window.updateDeliveryBoxCart(), 800);
// });
// Origin code


// // =======================
// // DELIVERY BOX CART SYNC (with skip_open fix)
// // =======================


// Drawer working perftly code 
window.__blockSmartCartOnLoad = true;
window.addEventListener('load', () => {
  setTimeout(() => {
    window.__blockSmartCartOnLoad = false;
  }, 10000); // 1.5s is enough
});


window.updateDeliveryBoxCart = async function() {
  if (window.__updatingDeliveryBoxCart) return;
  window.__updatingDeliveryBoxCart = true;
if (window.__blockSmartCartOnLoad && window.Rebuy?.SmartCart) {
  console.log("window.Rebuy?.SmartCart",window.__blockSmartCartOnLoad);
  
  Rebuy.SmartCart.skip_open = true;
}else{
  console.log("window.Rebuy?.SmartCart",window.__blockSmartCartOnLoad);

}

   
  if (window.__blockSmartCartOnLoad === true) {

  // ✅ Detect Add to Cart FORM submit
  document.addEventListener('submit', function (e) {
    const form = e.target;

    if (
      form.matches('form[action^="/cart/add"]') ||
      form.querySelector('input[name="id"]')
    ) {
      // User explicitly added to cart → allow drawer
      window.__blockSmartCartOnLoad = false;

      if (window.Rebuy?.SmartCart) {
        Rebuy.SmartCart.skip_open = false;
      }
    }
  }, true); // capture phase

  // ✅ Detect Add to Cart BUTTON click
  document.addEventListener('click', function (e) {
    const btn = e.target.closest(
      '.addtocart.product-form__submit.button.button--full-width.button--secondary'
    );

    if (btn) {
      // User explicitly clicked Add to Cart → allow drawer
      window.__blockSmartCartOnLoad = false;

      if (window.Rebuy?.SmartCart) {
        Rebuy.SmartCart.skip_open = false;
      }
    }
  }, true); // capture phase
}


  try {
    const cart = await fetch('/cart.js').then(res => res.json());
    if (!cart) return;

    const metafieldMap = {}; 
    const metafieldVariantsSet = new Set();

    const productHandles = [...new Set(cart.items.map(i => i.handle))];
    if (productHandles.length === 0) return;

    const joinedHandles = productHandles.join('@@');
    const firstHandle = productHandles[0];
    const ajaxURL = `/products/${firstHandle}?view=ajax-data&handle=${joinedHandles}`;

    const res = await fetch(ajaxURL);
    const text = await res.text();

    let productDataCache = {};
    try { productDataCache = JSON.parse(text.trim()); } 
    catch (e) { console.warn("Failed to parse metafield data:", text); }

    for (const id of Object.values(productDataCache)) {
      if (id && !isNaN(id)) metafieldVariantsSet.add(Number(id));
    }

    for (const item of cart.items) {
      if (metafieldVariantsSet.has(item.variant_id)) continue;
      const addonVariant = productDataCache[item.handle];
      if (addonVariant && !isNaN(addonVariant)) {
        if (!metafieldMap[addonVariant]) metafieldMap[addonVariant] = { qty: 0, parents: new Set() };
        metafieldMap[addonVariant].qty += item.quantity;
        metafieldMap[addonVariant].parents.add(item.product_id);
      }
    }

    const existing = {};
    cart.items.forEach(i => {
      existing[i.variant_id] = { qty: i.quantity, key: i.key, properties: i.properties || {} };
    });

    function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
    // 🟢 Add/update hidden addons WITHOUT triggering Smart Cart
    for (const [variantId, data] of Object.entries(metafieldMap)) {
      const desiredQty = data.qty;
      const parentIds = Array.from(data.parents).join(',');
      const props = { _delivery_parents: parentIds };
      const existingItem = existing[variantId];

      Rebuy.SmartCart.skip_open = true; // prevent cart opening

      if (!existingItem) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: desiredQty, properties: props })
        });
      } else {
        const currentQty = existingItem.qty;
        const currentProps = existingItem.properties._delivery_parents || '';
        if (currentQty !== desiredQty || currentProps !== parentIds) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: existingItem.key || Number(variantId),
              quantity: desiredQty,
              properties: props
            })
          });
        }
      }
      if (window.__blockSmartCartOnLoad ===false) { 
        setTimeout(() => { Rebuy.SmartCart.skip_open = false; },1000);
      }
    }
      if (window.__blockSmartCartOnLoad ===true) { 
        setTimeout(() => { Rebuy.SmartCart.skip_open = false; },10000);
      }
    // Remove orphaned addons also without triggering drawer
    const currentParentIds = new Set(cart.items.map(i => i.product_id));
    for (const item of cart.items) {
      if (item.properties && item.properties._delivery_parents) {
        const parentIds = item.properties._delivery_parents
          .split(',')
          .map(v => v.trim())
          .filter(Boolean);
        const stillExists = parentIds.some(pid => currentParentIds.has(Number(pid)));
        if (!stillExists) {
          Rebuy.SmartCart.skip_open = true;
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key || item.variant_id, quantity: 0 })
          });
          setTimeout(() => { Rebuy.SmartCart.skip_open = false; }, 500);
        }
      }
    }

  } catch (err) {
    console.error("updateDeliveryBoxCart error:", err);
  } finally {
    window.__updatingDeliveryBoxCart = false;
  }
};

// 🔄 Debounced event integration (NO drawer trigger)
let rebuyUpdateTimeout;

const debounceUpdate = () => {
  clearTimeout(rebuyUpdateTimeout);

  rebuyUpdateTimeout = setTimeout(() => {
    // 🔒 Prevent Smart Cart from opening due to sync updates
    Rebuy.SmartCart.skip_open = true;

    window.updateDeliveryBoxCart();

    // 🔓 Re-enable Smart Cart after updates settle
    setTimeout(() => {
      Rebuy.SmartCart.skip_open = false;
    }, 500);

  }, 700);
};
// document.addEventListener('rebuy:cart.add', debounceUpdate);
document.addEventListener('rebuy:cart.change', debounceUpdate);
document.addEventListener('rebuy:smartcart.line-item-increase', debounceUpdate);
document.addEventListener('rebuy:smartcart.line-item-decrease', debounceUpdate);

document.addEventListener('rebuy:smartcart.line-item-removed', () => {
  setTimeout(() => {
    Rebuy.SmartCart.skip_open = true;

    window.updateDeliveryBoxCart();

    setTimeout(() => {
      Rebuy.SmartCart.skip_open = false;
    }, 500);
  }, 800);
});


